const tailwindSizes = {
  xl2: 1536,
  xl: 1280,
  lg: 1024,
  md: 768,
  sm: 640,
};

export default tailwindSizes;
